import { ConnectError } from '@connectrpc/connect'
import { t } from 'i18next'

type Params = {
  fallbackKey?: string
  error: unknown
}
export function getErrorMessage({
  error,
  fallbackKey = 'common:error.error_occurred',
}: Params): string {
  if (error instanceof ConnectError) {
    return error.rawMessage
  }
  if (error instanceof Error) {
    return error.message
  }
  return t(fallbackKey)
}
